import axios from "axios";
import { Feature } from "ol";
import { EsriJSON } from "ol/format";
import { Geometry, Point } from "ol/geom";
import { config } from "./config";
import { coordinatesConverter, EpsgCode } from "@geo/js";

const params = {
  f: "json",
  returnGeometry: true,
  where: "1=1",
  outFields: "*",
  outSR: "3857",
};

const esrijsonFormat = new EsriJSON();

export const getAllFeatures = async (
  layerId?: number
): Promise<Feature<Geometry>[]> => {
  const url = new URL(window.location.href);
  const urlParams = new URLSearchParams(url.search.slice(1));
  const id = urlParams.get("layerid") || layerId;

  return [].concat(
    ...(await Promise.all([
      getFeatures(config.objects.url + "/" + id + "/query"),
    ]))
  );
};

const getFeatures = async (url: string): Promise<Feature<Geometry>[]> => {
  try {
    const response = await axios.get(url, { params });
    if (!response || !response.data || response.data.error) {
      throw new Error(
        response.data.error.message +
          "\n" +
          response.data.error.details.join("\n")
      );
    }
    const parsed = esrijsonFormat.readFeatures(response.data);
    const features = parsed.filter(
      (f) => (f.getGeometry() as Point).getCoordinates() && f
    );
    fixData(features);
    addCoordinates(features);
    return sort(features);
  } catch (err) {
    // console.log(err);
    return [];
  }
};

const fixData = (features: Feature[]) => {
  for (const feature of features) {
    const properties = {
      VISITED: 0,
      LIKE: 0,
      SELECTED: 0,
    };

    feature.setProperties(properties);
  }
};

const addCoordinates = (features: Feature[]) => {
  for (const feature of features) {
    const wgs84 = coordinatesConverter.convert(
      (feature.getGeometry() as Point).getCoordinates(),
      EpsgCode.WebMercator,
      EpsgCode.Wgs84
    );
    const lks92 = coordinatesConverter.convert(
      (feature.getGeometry() as Point).getCoordinates(),
      EpsgCode.WebMercator,
      EpsgCode.Lks92
    );

    feature.setProperties({ WGS84: wgs84, LKS92: lks92 });
  }
};

const sort = (features: Feature[]) => {
  if (!features.length) {
    return [];
  }
  const dabaskartesFeatures = [];
  const otherFeatures = [];
  for (const feature of features) {
    feature.get("PLACESUBTYPE") === 7
      ? dabaskartesFeatures.push(feature)
      : otherFeatures.push(feature);
  }
  return dabaskartesFeatures.concat(otherFeatures);
};
